import convertFromHtml from 'html-to-draft';
import { BLOCK_TYPE, ENTITY_TYPE } from './CONSTANTS';
import { isExternalImage, isBase64Image } from './fileUtilities';

const parseRows = (element, rows = []) => {
    Array.from(element.childNodes).forEach((child) => {
        if (['TR'].includes(child.nodeName)) {
            rows.push([]);
        }

        if (['TH', 'TD'].includes(child.nodeName)) {
            // eslint-disable-next-line
            rows[rows.length - 1].push(convertHtml(child.innerHTML));
        } else {
            parseRows(child, rows);
        }
    });

    return rows;
};

const parseBlock = (element) => {
    let block = null;

    if (element.nodeName === 'HR') {
        block = {
            type: BLOCK_TYPE.ATOMIC,
            entity: {
                type: BLOCK_TYPE.HR,
            },
        };
    } else if (element.nodeName === 'BR') {
        block = {
            type: BLOCK_TYPE.UNSTYLED,
        };
    } else if (element.nodeName === 'TABLE') {
        block = {
            type: BLOCK_TYPE.ATOMIC,
            entity: {
                type: BLOCK_TYPE.TABLE,
                mutability: 'IMMUTABLE',
                data: {
                    rows: parseRows(element),
                },
            },
        };
    } else if (element.nodeName === 'IMG') {
        block = {
            type: BLOCK_TYPE.ATOMIC,
            entity: {
                type: ENTITY_TYPE.IMAGE,
                mutability: 'IMMUTABLE',
                data: {
                    src: element.src,
                    alt: element.alt,
                    isExternalPastedImage: isExternalImage(element.src),
                    isBase64Image: isBase64Image(element.src),
                },
            },
        };
    }

    return block;
};

const convertHtml = html => convertFromHtml(html, { parseBlock });

export default convertHtml;
